import React, { useState, useCallback, cloneElement } from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import { noop } from '../../utils/noop.esm.js';
import '@popperjs/core';

const buttonId = (el) => {
    const button = el.closest("button");
    return (button === null || button === void 0 ? void 0 : button.disabled) ? null : button === null || button === void 0 ? void 0 : button.id;
};
const SubTabList = ({ activeSubTabId, children, dataMetrics, dataTestId, disabled = false, onActiveChange = noop, }) => {
    const [focusedSubTabId, setFocusedTabId] = useState(null);
    const subTabArray = React.Children.toArray(children).filter(Boolean);
    const onClick = useCallback((e) => {
        const id = buttonId(e.target);
        if (!id)
            return;
        onActiveChange(id);
        setFocusedTabId(id);
    }, [onActiveChange, setFocusedTabId]);
    const enabledSubTabs = subTabArray.filter((subTab) => !subTab.props.disabled);
    const onKeyDown = useCallback((e) => {
        const id = buttonId(e.target);
        const rightArrow = 39;
        const leftArrow = 37;
        const focusedTab = enabledSubTabs.find((subTab) => subTab.props.id === id);
        let nextFocusedTabIndex = focusedTab
            ? enabledSubTabs.indexOf(focusedTab)
            : 0;
        if (e.keyCode === rightArrow || e.keyCode === leftArrow) {
            e.preventDefault();
            // Move right
            if (e.keyCode === rightArrow) {
                nextFocusedTabIndex++;
                // If we're at the end, go to the start
                if (nextFocusedTabIndex >= enabledSubTabs.length) {
                    nextFocusedTabIndex = 0;
                }
            }
            // Move left
            if (e.keyCode === leftArrow) {
                nextFocusedTabIndex--;
                // If we're at the start, move to the end
                if (nextFocusedTabIndex < 0) {
                    nextFocusedTabIndex = enabledSubTabs.length - 1;
                }
            }
            setFocusedTabId(enabledSubTabs[nextFocusedTabIndex].props.id);
        }
    }, [children, focusedSubTabId, setFocusedTabId]);
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || "subtab-list", role: "tablist", className: classNames("tw-border-0 tw-flex tw-overflow-auto tw-scrollbar-small dark:tw-scrollbar-track-dark dark:tw-scrollbar-thumb-dark dark:tw-scrollbar-corner-dark tw-bg-gray-100 dark:tw-bg-gray-1000"), onClick: onClick, onKeyDown: onKeyDown },
        React.createElement("div", { className: "tw-flex" }, subTabArray.map((subTab, i) => {
            return cloneElement(subTab, {
                ...subTab.props,
                active: activeSubTabId === subTab.props.id,
                disabled: disabled || subTab.props.disabled,
                isFirst: i === 0,
                isLast: i === subTabArray.length - 1,
                hasFocus: focusedSubTabId !== null && focusedSubTabId === subTab.props.id,
            });
        }))));
};

export { SubTabList };
//# sourceMappingURL=SubTabList.esm.js.map
